import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
    //static readonly DATE_FMT = 'MMM/dd/yyyy';
    transform(value: any, args?: any): any {
        return super.transform(value, `${'MM/dd/yyyy'} hh:mm:ss`);
    }
}

